export const getRolesUrl = (offset: number, rows: number) => {
  return `/admin/roles?offset=${offset}&rows=${rows}`;
};

export const createRoleUrl = () => {
  return `/admin/roles`;
};